export const PageSizes = [10, 25, 50, 100] as const;
export type PageSize = (typeof PageSizes)[number] | null;

export type PaginatedPageDetails = {
	start: number;
	end: number;
	total: number;
};
